import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as L from 'leaflet';
import { UtilsPropertiesService } from 'src/app/services/utils-properties.service';



@Component({
  selector: 'app-map-view',
  templateUrl: './map-view.component.html',
  styleUrls: ['./map-view.component.css']
})
export class MapViewComponent implements OnInit, AfterViewInit {

  @Input() properties!: any[];
  private map: any;
  entityData: any;
  markerClusterData: L.Marker[] = [];
  seePropertyText = 'See Property';

  constructor(
    public utilsPropertiesService: UtilsPropertiesService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    const data: any = localStorage.getItem('entityData');
    this.entityData = JSON.parse(data);
    this.seePropertyText = this.translateService.instant('t-see-property');
  }

  ngAfterViewInit(): void {
    this.initMap();
  }

  private initMap(): void {

    let markers = L.markerClusterGroup();

    const lat = this.entityData.latitude ? this.entityData.latitude : 41.1807397;
    const lng = this.entityData.longitude ? this.entityData.longitude : -8.6827037;

    this.map = L.map('map', {
      attributionControl: false,
      center: [lat, lng],
      zoom: 8
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      minZoom: 4,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });
    tiles.addTo(this.map);

    L.control.attribution({
      position: 'topright'
    }).addTo(this.map);

    const icon: L.Icon = L.icon({
      iconUrl: 'assets/images/marker-icon.png',
      shadowUrl: 'assets/images/marker-shadow.png',
      iconSize: [24, 36],
      iconAnchor: [12, 36]
      // specify the path here
    })
    this.properties.forEach(el => {
      if (el.latitude && el.longitude) {
        const reference = el.reference.toLowerCase();
        const popup = `
        <div class="popup-image">
          <img src="${el.media[0].file}" alt="home-1" class="img-responsive img-map-popup">
        </div>
        <div class="popup-info pt-3 px-2">
          <h3 class="fs-6 mb-0">${el.title}</h3>
          <div class="align-items-center d-flex justify-content-between">
          <p class="fs-6 homes-address my-0">
            <i class="fa fa-map-marker me-1"></i><span>${el.district ? el.district : el?.region}</span>
          </p>
          <h3 class="fs-6 m-0">
            ${this.priceFormat(el.price)}
          </h3>
          </div>

          <a onclick="document.getElementById('${reference}').click()" class="see-property">${this.seePropertyText}</a>
        </div>

      `
        const lat = parseFloat(el.latitude);
        const lng = parseFloat(el.longitude);
        const marker = L.marker([lat, lng], { icon: icon });
        marker.bindPopup(popup, {
          autoClose: true,
        });

        markers.addLayer(marker);
      }
    });

    this.map.addLayer(markers);
  }

  priceFormat(propertyPrice: any, symbol: any = '€') {
    const spaces = (price: any) => String(price)
      .replace(
        /(?!^)(?=(?:\d{3})+$)/g,
        ' '
      );
    return symbol + ' ' + spaces(propertyPrice);
  }


}
